import apiClient from './apiClient';

export interface RevenueChartPoint {
  date: string;
  revenue: number;
  commission: number;
}

export interface JobsChartPoint {
  date: string;
  created: number;
  completed: number;
  cancelled: number;
}

export interface UsersChartPoint {
  date: string;
  total: number;
  artisans: number;
  clients: number;
}

export interface RevenueSummary {
  total_revenue: number;
  total_commission: number;
  avg_per_day: number;
}

export interface JobsSummary {
  total_created: number;
  total_completed: number;
  total_cancelled: number;
  completion_rate: number;
}

export interface UsersSummary {
  total_new: number;
  total_artisans: number;
  total_clients: number;
  total_all_time: number;
}

export interface RevenueReport {
  chart: RevenueChartPoint[];
  summary: RevenueSummary;
}

export interface JobsReport {
  chart: JobsChartPoint[];
  summary: JobsSummary;
}

export interface UsersReport {
  chart: UsersChartPoint[];
  summary: UsersSummary;
}

class ReportService {
  async getRevenueReport(range: 'week' | 'month' | 'year'): Promise<RevenueReport> {
    const response = await apiClient.get('/admin/reports/', {
      params: { type: 'revenue', range },
    });
    return response.data.data;
  }

  async getJobsReport(range: 'week' | 'month' | 'year'): Promise<JobsReport> {
    const response = await apiClient.get('/admin/reports/', {
      params: { type: 'jobs', range },
    });
    return response.data.data;
  }

  async getUsersReport(range: 'week' | 'month' | 'year'): Promise<UsersReport> {
    const response = await apiClient.get('/admin/reports/', {
      params: { type: 'users', range },
    });
    return response.data.data;
  }
}

export default new ReportService();
